const loggerHolderStyles = {
  'font-size': '1.0rem',
  'z-index': '100000000',
  left: '50px',
  position: 'absolute',
  top: '390px',
  width: '1800px',
}
const loggerStyles = {
  background: 'rgba(0, 0, 0, 0.4)', //duplicate because we're not using css/classes
  height: '340px',
  overflow: 'hidden',
}
const networkLoggerStyles = {
  'margin-top': '20px',
  background: 'rgba(0, 0, 0, 0.4)',
  height: '300px',
  overflow: 'hidden',
}

const consoleColors = {
  error: 'red',
  info: 'greenyellow',
  log: 'white',
  warn: 'yellow',
}

const screenLoggerId = 'screenLogger'

export function createScreenLogger() {
  if (document.getElementById(screenLoggerId)) {
    return
  }

  //Set up elements
  const consoleLogger = document.createElement('div')
  consoleLogger.id = screenLoggerId + 'console'
  Object.entries(loggerStyles).forEach(([property, value]) => {
    consoleLogger.style[property] = value
  })

  const networkLogger = document.createElement('div')
  networkLogger.id = screenLoggerId + 'network'
  Object.entries(networkLoggerStyles).forEach(([property, value]) => {
    networkLogger.style[property] = value
  })

  const loggerHolder = document.createElement('div')
  loggerHolder.id = screenLoggerId
  Object.entries(loggerHolderStyles).forEach(([property, value]) => {
    loggerHolder.style[property] = value
  })

  const rootElement = document.getElementById('root')
  loggerHolder.appendChild(consoleLogger)
  loggerHolder.appendChild(networkLogger)
  rootElement.insertBefore(loggerHolder, rootElement.firstChild)

  //Set up console overrides
  const isError = (param) => param instanceof Error
  const isObject = (param) =>
    !isError(param) && (Array.isArray(param) || typeof param === 'object')

  const getString = (param) => {
    if (isError(param)) {
      return `${param.message} ${param.stack}`
    }
    if (isObject(param)) {
      return JSON.stringify(param, null, '  ')
    }
    return param
  }

  for (var level in consoleColors) {
    const fn = console[level]
    const color = consoleColors[level]
    console[level] = (...args) => {
      //Call the original console function
      fn.call(console, ...args)
      //Create a paragraph element to append to the screen logger
      const p = document.createElement('p')
      const text = document.createTextNode(args.map(getString).join(' '))
      p.style['color'] = color
      p.appendChild(text)
      document.getElementById(screenLoggerId + 'console').appendChild(p)
    }
  }

  //Listen for network events
  XMLHttpRequest.prototype.realSend = XMLHttpRequest.prototype.send
  XMLHttpRequest.prototype.send = function (value) {
    this.addEventListener(
      'loadend',
      function (e) {
        const isError = e.target.status >= 400 || e.target.status === 0

        const p = document.createElement('p')

        const status = document.createElement('span')
        const url = document.createElement('span')
        const bytes = document.createElement('span')
        const response = document.createElement('span')

        status.textContent = e.target.status
        url.textContent = isError ? e.target._url : e.target.responseURL
        bytes.textContent = (isError ? 0 : e.target.response.length) + ' bytes'
        response.textContent =
          e.target.response.slice(
            0,
            220 - (url.textContent.length + bytes.textContent.length)
          ) + ' ...'

        status.style['color'] = isError
          ? consoleColors.error
          : consoleColors.info
        url.style['color'] = consoleColors.log
        bytes.style['color'] = consoleColors.warn
        response.style['color'] = consoleColors.info

        p.appendChild(status)
        p.appendChild(url)
        p.appendChild(bytes)
        p.appendChild(response)

        document.getElementById(screenLoggerId + 'network').appendChild(p)
      },
      false
    )
    this.realSend(value)
  }
  //Save request url for usage in log message
  XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url
    this.origOpen.apply(this, arguments)
  }
}

export function clearScreenLogger() {
  const logger = document.getElementById(screenLoggerId)
  if (logger !== null) {
    for (let i = 0; i < logger.childNodes.length; i++) {
      while (logger.childNodes[i].firstChild) {
        logger.childNodes[i].removeChild(logger.childNodes[i].lastChild)
      }
    }
  }
}

export function setScreenLoggerVisibility(visible) {
  const logger = document.getElementById(screenLoggerId)
  if (logger) {
    logger.style.visibility = visible ? 'visible' : 'hidden'
  }
}
